<template lang="">
    <div class="modal">
        <a  class="modal_close" @click="$emit('close')"></a>
        <div class="modal_body">
            <div class="ico_box check">
            </div>
            <p class=common_txt>
                정상적으로 탈퇴 처리되었습니다. <br> 그동안 이용해 주셔서 감사합니다.
            </p>
            <div class="common_btn">
                <button type="button" class="btn_ok">확인</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>